var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 30.815C13.3272 30.8149 13.1574 30.7702 13.007 30.685L4.507 25.87C4.35309 25.7828 4.22507 25.6563 4.136 25.5035C4.04694 25.3506 4.00001 25.1769 4 25V15C4.00001 14.8231 4.04694 14.6494 4.136 14.4965C4.22507 14.3437 4.35309 14.2172 4.507 14.13L13.007 9.315C13.1574 9.2299 13.3272 9.18518 13.5 9.18518C13.6728 9.18518 13.8426 9.2299 13.993 9.315L22.493 14.13C22.6469 14.2172 22.7749 14.3437 22.864 14.4965C22.9531 14.6494 23 14.8231 23 15V25C23 25.1769 22.9531 25.3506 22.864 25.5035C22.7749 25.6563 22.6469 25.7828 22.493 25.87L13.993 30.685C13.8426 30.7702 13.6728 30.8149 13.5 30.815ZM6 24.417L13.5 28.665L21 24.417V15.583L13.5 11.335L6 15.582V24.417Z",
    fill: "#3952BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.5 11.5L5.5 16V24.5L13.5 29.5L21.5 25V15.5L13.5 11.5Z",
    fill: "#3952BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17H26V7.583L18.5 3.335L10.493 7.87L9.50699 6.13L18.007 1.315C18.1574 1.22991 18.3272 1.18518 18.5 1.18518C18.6728 1.18518 18.8426 1.22991 18.993 1.315L27.493 6.13C27.6469 6.21721 27.7749 6.34369 27.864 6.49653C27.9531 6.64937 28 6.8231 28 7V17Z",
    fill: "#3952BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbon);
export default __webpack_public_path__ + "static/media/carbon.ff245a3051f5ed2041586e09296ac2b2.svg";
export { ForwardRef as ReactComponent };